import DateFnsUtils from '@date-io/date-fns/build';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { trackPromise } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { onError } from 'src/store/actions/popupActions';
import { PPA_CONTRACT_RESET, PPA_CONTRACT_VALUE_CHANGE } from 'src/store/PpaContract/PpaContractActionTypes';
import axios from '../../axios/AxiosInterceptors';
import moment from 'moment/moment';

const PpaContractComponent = (props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const ppaContract = useSelector(state => state.ppaContract.ppaContract);
    const [isEdit, setIsEdit] = useState(true);
    const [generators, setGenerators] = useState([{ id: 0, generatorName: '' }]);

    useEffect(() => {
        setIsEdit(props.isEdit);
        retrieveGenerators();
        return () => { dispatch({ type: PPA_CONTRACT_RESET }) }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params])

    const retrieveGenerators = async () => {
        await trackPromise(axios.get("/account-service/v1/account/" + params.accountId + "/generator").then(response => {
            if (response && response.data) {
                generators.push(...response.data);
                setGenerators([...generators]);
            }
        }).catch(error => {
            dispatch(onError(error.response));
        }));
    }

    const handleTextValueChange = (e, fieldName) => {
        ppaContract[fieldName] = e.target.value;
        dispatch({ type: PPA_CONTRACT_VALUE_CHANGE, ppaContract: ppaContract });
    }

    const handleGeneratorChange = (e, value) => {
        ppaContract.ppaGenerator = value;
        dispatch({ type: PPA_CONTRACT_VALUE_CHANGE, ppaContract: ppaContract });
    }

    const handleSettlementTypeChange = (e) => {
        ppaContract.settlementType = e.target.value;
        dispatch({ type: PPA_CONTRACT_VALUE_CHANGE, ppaContract: ppaContract });
    }

    const handlePricingTypeChange = (e) => {
        ppaContract.dayAheadOrRealTime = e.target.value;
        dispatch({ type: PPA_CONTRACT_VALUE_CHANGE, ppaContract: ppaContract });
    }

    const handleStartDateChange = (date) => {
        ppaContract.startDate = moment(date);
        if (ppaContract.endDate) {
            ppaContract.termLengthMonth = ppaContract.endDate.diff(ppaContract.startDate, 'months');
        }
        dispatch({ type: PPA_CONTRACT_VALUE_CHANGE, ppaContract: ppaContract })
    }

    const handleEndDateChange = (date) => {
        ppaContract.endDate = moment(date);
        if (ppaContract.startDate) {
            ppaContract.termLengthMonth = ppaContract.endDate.diff(ppaContract.startDate, 'months');
        }
        dispatch({ type: PPA_CONTRACT_VALUE_CHANGE, ppaContract: ppaContract })
    }

    const getOptionSelected = (option, value) => {
        return option.id === value.id;
    }

    const getOptionLabel = (option) => {
        return option.generatorName ? option.generatorName : ''
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={4}>
                <Autocomplete value={ppaContract.ppaGenerator} onChange={(e, value) => handleGeneratorChange(e, value)} options={generators}
                    getOptionLabel={(option) => getOptionLabel(option)} renderInput={(params) => <TextField {...params} label="Generator" />}
                    getOptionSelected={(option, value) => getOptionSelected(option, value)} disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={4}>
                <TextField name="offtakerName" id="offtakerName" value={ppaContract.offtakerName}
                    onChange={(e, fieldName) => handleTextValueChange(e, "offtakerName")} label="Offtaker Name" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={4} />
            <Grid item xs={6} sm={4}>
                <FormControl disabled={!isEdit}>
                    <FormLabel>Settlement Type</FormLabel>
                    <RadioGroup row value={ppaContract.settlementType} onChange={handleSettlementTypeChange}>
                        <FormControlLabel value="financial" control={<Radio />} label="Financial" />
                        <FormControlLabel value="physical" control={<Radio />} label="Physical" />
                        <FormControlLabel value="other" control={<Radio />} label="Other" />
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={4} />
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={4}>
                <TextField name="deliveryPointPnode" id="deliveryPointPnode" value={ppaContract.deliveryPointPnode}
                    onChange={(e, fieldName) => handleTextValueChange(e, "deliveryPointPnode")} label="Delivery Point PNode Name" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={4}>
                <TextField name="deliveryPointPnodeId" id="deliveryPointPnodeId" value={ppaContract.deliveryPointPnodeId}
                    onChange={(e, fieldName) => handleTextValueChange(e, "deliveryPointPnodeId")} label="Delivery Point PNode Id" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={4} />
            <Grid item xs={6} sm={4}>
                <FormControl disabled={!isEdit}>
                    <FormLabel>PricingType</FormLabel>
                    <RadioGroup row value={ppaContract.dayAheadOrRealTime} onChange={handlePricingTypeChange}>
                        <FormControlLabel value="dayAhead" control={<Radio />} label="Day-Ahead" />
                        <FormControlLabel value="realTime" control={<Radio />} label="Real-Time" />
                        <FormControlLabel value="other" control={<Radio />} label="Other" />
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={4} />
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker variant="inline" disableToolbar onChange={(date) => handleStartDateChange(date)} value={ppaContract.startDate} autoOk={true} margin="normal" format="yyyy-MM-dd" disabled={!isEdit} />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker variant="inline" disableToolbar onChange={(date) => handleEndDateChange(date)} value={ppaContract.endDate} autoOk={true} margin="normal" format="yyyy-MM-dd" disabled={!isEdit} />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <NumberFormat name="termLengthMonth" id="termLengthMonth" value={ppaContract.termLengthMonth}
                    label="Term Length (Months)" fullWidth disabled={true} thousandSeparator={true} decimalScale={0} fixedDecimalScale customInput={TextField} suffix=" Months" placeholder="Months" />
            </Grid>
            <Grid item xs={6} sm={1} />
        </Grid>
    )

}

export default PpaContractComponent;